import { z } from 'zod';
export const CreateTermsTemplateSchema = z.object({
    name: z.string().min(1).max(100),
    body: z.string().min(1),
});
export const UpdateTermsTemplateSchema = CreateTermsTemplateSchema.partial();
export const TermsTemplateResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    body: z.string(),
    isDefault: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
//# sourceMappingURL=terms-templates.js.map